import { action } from 'satcheljs';

export interface OnCopilotChatDrawerAutoOpenPrerequisiteChangedMessage {
    targetWindow: Window;
}

export const onCopilotChatDrawerAutoOpenPrerequisiteChanged: (
    targetWindow: Window
) => OnCopilotChatDrawerAutoOpenPrerequisiteChangedMessage = action(
    'onCopilotChatDrawerAutoOpenPrerequisiteChanged',
    (targetWindow: Window): OnCopilotChatDrawerAutoOpenPrerequisiteChangedMessage => ({
        targetWindow,
    })
);
